import React from 'react';

import { LOGIN_MODE, type LoginProps } from '../types';
import { OtpLoginForm } from './OtpLoginForm';
import { PasswordLoginCard } from './PasswordLoginCard';
import { useLoginMode } from '../hooks/useLoginMode';

export const Login = (props: LoginProps) => {
  const { initialEmail, onSignup, onForgotPassword, onChangeEmail } = props;
  const { submitLabel, passwordSubtitle, signupLabel } = props;
  const { onModeSelected, onCodeSent, onCodeValidated, onLoginCompleted } = props;
  const { mode, switchToOtp, switchToPassword } = useLoginMode();

  const pickOtp = () => {
    switchToOtp();
    onModeSelected?.(LOGIN_MODE.OTP);
  };

  const pickPassword = () => {
    switchToPassword();
    onModeSelected?.(LOGIN_MODE.PASSWORD);
  };

  const completeOtpLogin = () => {
    onCodeValidated?.();
    onLoginCompleted?.(LOGIN_MODE.OTP);
  };

  if (mode === LOGIN_MODE.OTP) {
    return (
      <OtpLoginForm
        initialEmail={initialEmail}
        active
        onSwitchToPassword={pickPassword}
        onSignup={onSignup}
        onEmailChange={onChangeEmail}
        onCodeSent={onCodeSent}
        onCodeValidated={completeOtpLogin}
        submitLabel={submitLabel}
        signupLabel={signupLabel}
      />
    );
  }

  return (
    <PasswordLoginCard
      initialEmail={initialEmail}
      onSwitchToOtp={pickOtp}
      onLoggedIn={() => onLoginCompleted?.(LOGIN_MODE.PASSWORD)}
      onForgotPassword={onForgotPassword}
      onSignup={onSignup}
      onEmailChange={onChangeEmail}
      submitLabel={submitLabel}
      subtitle={passwordSubtitle}
      signupLabel={signupLabel}
    />
  );
};

export default Login;
